import React from 'react';
import {useTranslation} from "react-i18next";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <>
      <div className="bg-theme-color pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-black text-white mb-4">{lang === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}</h1>
          <p className="text-white/70">{lang === 'ar' ? 'آخر تحديث: يناير 2026' : 'Last updated: January 2026'}</p>
        </div>
      </div>
      <div className="hidden max-w-4xl mx-auto px-4 py-16 prose prose-lg">
        <div className="space-y-8 text-gray-700">
          {[
            { title: lang === 'ar' ? 'جمع المعلومات' : 'Information We Collect', body: lang === 'ar' ? 'نجمع المعلومات التي تقدمها لنا طوعاً عند استخدام خدماتنا، مثل الاسم وعنوان البريد الإلكتروني ورقم الهاتف وتفاصيل المشروع.' : 'We collect information you voluntarily provide when using our services, such as your name, email address, phone number, and project details.' },
            { title: lang === 'ar' ? 'استخدام المعلومات' : 'How We Use Information', body: lang === 'ar' ? 'نستخدم معلوماتك للتواصل معك بشأن طلباتك، وتقديم عروض الأسعار، وتسليم مشاريعك في الوقت المحدد.' : 'We use your information to respond to your inquiries, provide quotes, and deliver your projects on time.' },
            { title: lang === 'ar' ? 'حماية البيانات' : 'Data Protection', body: lang === 'ar' ? 'نطبق معايير أمان صارمة لحماية بياناتك. لا نبيع أو نتاجر ببياناتك الشخصية لأطراف ثالثة.' : 'We implement strict security standards to protect your data. We never sell or trade your personal information to third parties.' },
            { title: lang === 'ar' ? 'تواصل معنا' : 'Contact Us', body: lang === 'ar' ? 'إذا كانت لديك أسئلة حول سياسة الخصوصية، يرجى التواصل معنا على info@majtech.ae' : 'If you have questions about this privacy policy, please contact us at hello@nexagen.io' },
          ].map((section, i) => (
            <div key={i} className="bg-gray-50 rounded-3xl p-8 border border-gray-100">
              <h2 className="text-2xl font-black text-gray-900 mb-4">{section.title}</h2>
              <p className="leading-relaxed">{section.body}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-700 mb-2">{t('privacyPolicyPage.privacyPolicy')}</h1>
            <p className="text-gray-600">{t('privacyPolicyPage.lastUpdated')}</p>
          </div>
          {/* Introduction */}
          <section className="mb-10">
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.introduction')}
            </p>
          </section>

          {/* Collecting and Using Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.collectingData')}</h2>

            <h3 className="text-xl font-medium text-gray-700 mb-2">{t('privacyPolicyPage.typesDataCollected')}</h3>
            <h4 className="text-lg font-medium text-gray-700 mb-2">{t('privacyPolicyPage.personalDataCollected')}</h4>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.personalDataCollectedText')}
            </p>

            <ul className="list-disc pl-5 space-y-2 mb-4">
              <li className="text-gray-500">{t('privacyPolicyPage.firstName')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.email')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.phone')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.address')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.usageData')}</li>
            </ul>

            <h4 className="text-lg font-medium text-gray-700 mb-2">{t('privacyPolicyPage.usageDataCollected')}</h4>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.usageDataCollectedText')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.usageDataDetails1')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.usageDataDetails2')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.usageDataDetails3')}
            </p>

            <h4 className="text-lg font-medium text-gray-700 mb-2">{t('privacyPolicyPage.infoCollectedApp')}</h4>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.infoCollectedAppText')}
            </p>

            <ul className="list-disc pl-5 space-y-2 mb-4">
              <li className="text-gray-500">{t('privacyPolicyPage.location')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.pictures')}</li>
            </ul>

            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.infoUsage')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.infoSettings')}
            </p>
          </section>
          {/* Use of Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.usePersonalData')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.usePersonalDataText')}
            </p>

            <ul className="list-disc pl-5 space-y-2 mb-4">
              <li className="text-gray-500">{t('privacyPolicyPage.provideService')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.manageAccount')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.performanceContract')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.contactYou')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.provideNews')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.manageRequests')}</li>
            </ul>

            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.shareInfo')}
            </p>

            <ul className="list-disc pl-5 space-y-2">
              <li className="text-gray-500"><strong>{t('privacyPolicyPage.withServiceProviders')}</strong> {t('privacyPolicyPage.withServiceProvidersText')}</li>
              <li className="text-gray-500"><strong>{t('privacyPolicyPage.businessTransfers')}</strong> {t('privacyPolicyPage.businessTransfersText')}</li>
              <li className="text-gray-500"><strong>{t('privacyPolicyPage.withAffiliates')}</strong> {t('privacyPolicyPage.withAffiliatesText')}</li>
              <li className="text-gray-500"><strong>{t('privacyPolicyPage.businessPartners')}</strong> {t('privacyPolicyPage.businessPartnersText')}</li>
              <li className="text-gray-500"><strong>{t('privacyPolicyPage.otherUsers')}</strong> {t('privacyPolicyPage.otherUsersText')}</li>
            </ul>
          </section>
          {/* Retention of Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.retentionData')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.retentionDataText')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.retentionUsageData')}
            </p>
          </section>
          {/* Transfer of Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.transferData')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.transferDataText1')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.transferDataText2')}
            </p>
          </section>
          {/* Disclosure of Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.disclosureData')}</h2>

            <h3 className="text-xl font-medium text-gray-700 mb-2">{t('privacyPolicyPage.businessTransactions')}</h3>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.businessTransactionsText')}
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-2">{t('privacyPolicyPage.lawEnforcement')}</h3>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.lawEnforcementText')}
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-2">{t('privacyPolicyPage.otherLegal')}</h3>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.otherLegalText')}
            </p>

            <ul className="list-disc pl-5 space-y-2">
              <li className="text-gray-500">{t('privacyPolicyPage.complyLegal')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.protectRights')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.preventWrongdoing')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.protectSafety')}</li>
              <li className="text-gray-500">{t('privacyPolicyPage.legalLiability')}</li>
            </ul>
          </section>
          {/* Security of Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.securityData')}</h2>
            <p className="text-gray-500">
              {t('privacyPolicyPage.securityDataText')}
            </p>
          </section>
          {/* Detailed Information on the Processing of Your Personal Data */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.processingDetails')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.processingDetailsText')}
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-2">{t('privacyPolicyPage.analytics')}</h3>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.analyticsText')}
            </p>

            <h4 className="text-lg font-medium text-gray-700 mb-2">{t('privacyPolicyPage.googleAnalytics')}</h4>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.googleAnalyticsText1')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.googleAnalyticsText2')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.googleAnalyticsText3')}
            </p>

            <h4 className="text-lg font-medium text-gray-700 mb-2">{t('privacyPolicyPage.firebase')}</h4>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.firebaseText1')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.firebaseText2')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.firebaseText3')}
            </p>
          </section>
          {/* Email Marketing */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.emailMarketing')}</h2>
            <p className="text-gray-500">
              {t('privacyPolicyPage.emailMarketingText')}
            </p>
          </section>
          {/* Your California Privacy Rights */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.californiaRights')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.californiaRightsText1')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.californiaRightsText2')}
            </p>
          </section>
          {/* California Privacy Rights for Minor Users */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.californiaMinors')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.californiaMinorsText1')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.californiaMinorsText2')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.californiaMinorsText3')}
            </p>
          </section>
          {/* Links to Other Websites */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.linksWebsites')}</h2>
            <p className="text-gray-500">
              {t('privacyPolicyPage.linksWebsitesText')}
            </p>
          </section>
          {/* Changes to this Privacy Policy */}
          <section className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700 mb-4">{t('privacyPolicyPage.changesPolicy')}</h2>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.changesPolicyText1')}
            </p>
            <p className="text-gray-500 mb-4">
              {t('privacyPolicyPage.changesPolicyText2')}
            </p>
            <p className="text-gray-500">
              {t('privacyPolicyPage.changesPolicyText3')}
            </p>
          </section>

        </div>
    </>
  );
};

export default PrivacyPolicy;